import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetofivejyotilingacab() {



const cardData = {
  keyword: "Pune to 5 Jyotirlinga Cab",
  heading: "Lotus Cab: Pune to 5 Jyotirlinga Cab",

  headingDescription:
    "Lotus Cab provides reliable and comfortable Pune to 5 Jyotirlinga cab services for spiritual journeys across Maharashtra. The 5 Jyotirlinga temples — Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath — attract thousands of devotees every year. Our outstation taxi service is designed for multi-day pilgrimage trips with flexible itineraries, transparent per kilometer pricing, and experienced highway drivers. Whether you need a one-way drop, round-trip package, or customized darshan plan, we offer AC sedans and spacious SUVs for safe long-distance travel. Ideal for family pilgrimages, senior citizen tours, and group temple visits, our vehicles are well-maintained and sanitized. With doorstep pickup across Pune and 24/7 booking support, Lotus Cab ensures a peaceful, smooth, and spiritually fulfilling travel experience.",

  top: "5 Jyotirlinga Temples Covered from Pune",

  topPlaces: [
    {
      title: "Bhimashankar Temple",
      description:
        "Bhimashankar, located in the Sahyadri hills, is one of the most sacred Jyotirlinga temples in Maharashtra. Surrounded by lush forest and peaceful nature, it attracts devotees and trekkers alike. The temple holds great spiritual importance in Hindu mythology. Pune to Bhimashankar cab service ensures safe hill-road travel. SUV vehicles are ideal for this route. Lotus Cab offers comfortable darshan trips with flexible waiting time."
    },
    {
      title: "Trimbakeshwar Temple",
      description:
        "Trimbakeshwar Temple near Nashik is one of the holiest Jyotirlingas and the origin of the Godavari River. The temple architecture and spiritual aura make it a must-visit pilgrimage site. Many devotees combine Trimbakeshwar with other Jyotirlinga visits. AC sedans and SUVs ensure comfortable highway travel. Lotus Cab provides multi-day temple tour planning."
    },
    {
      title: "Grishneshwar Temple",
      description:
        "Grishneshwar Temple near Chhatrapati Sambhaji Nagar is the 12th Jyotirlinga and holds immense spiritual value. Located close to Ellora Caves, it attracts pilgrims and tourists together. Long-distance cab travel from Pune ensures safe interstate journeys. Spacious vehicles are recommended for group temple tours."
    },
    {
      title: "Aundha Nagnath Temple",
      description:
        "Aundha Nagnath Temple is one of the oldest Jyotirlinga temples in Maharashtra. It is a peaceful pilgrimage destination visited by thousands annually. The route requires experienced highway drivers. Lotus Cab ensures safe and timely darshan visits."
    },
    {
      title: "Parli Vaijnath Temple",
      description:
        "Parli Vaijnath is another sacred Jyotirlinga temple attracting devotees from across India. It is often included in 5 Jyotirlinga multi-day yatra plans. Comfortable SUV taxis are ideal for family pilgrimage trips. Lotus Cab provides customized tour packages for complete darshan coverage."
    }
  ],

  services: [
    {
      name: "Pune to Jyotirlinga Temples Cab",
      description:
        "Lotus Cab offers complete Pune to 5 Jyotirlinga cab packages covering Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Ideal for multi-day spiritual travel with flexible itinerary options. AC sedans and SUVs available for comfortable long-distance journeys. Professional drivers familiar with temple routes ensure safe travel. Transparent per kilometer pricing provided."
    },
    {
      name: "Pune to Jyotirlinga One Way Cab",
      description:
        "Affordable one-way taxi service for devotees planning temple visits with flexible drop locations and safe highway travel."
    },
    {
      name: "Pune to Jyotirlinga Round Trip Taxi",
      description:
        "Convenient round-trip taxi packages with return scheduling flexibility for complete darshan coverage."
    },
    {
      name: "SUV Cab Pune to Jyotirlinga",
      description:
        "Spacious SUV cab service suitable for family pilgrimages and group temple tours with luggage support."
    },
    {
      name: "Luxury Cab Pune to Jyotirlinga",
      description:
        "Premium cab options offering enhanced comfort for senior citizens and long-distance spiritual journeys."
    },
    {
      name: "Group Tour Cab Pune to Jyotirlinga",
      description:
        "Dedicated group travel taxi services ideal for religious tours and multi-family pilgrimage trips."
    },
    {
      name: "Online Booking Pune to Jyotirlinga",
      description:
        "Instant online cab booking with 24/7 customer assistance and customized temple travel planning."
    },
    {
      name: "Outstation Taxi Service Pune to Jyotirlinga",
      description:
        "Reliable outstation taxi service with experienced drivers and AC vehicles for peaceful temple visits."
    }
  ],

  tableData: [
    ["Pune to 5 Jyotirlinga Cab", "Pune to Jyotirlinga Temples Cab"],
    ["Pune to Jyotirlinga One Way Cab", "Pune to Jyotirlinga Round Trip Taxi"],
    ["Affordable Cab Pune to Jyotirlinga", "Luxury Cab Pune to Jyotirlinga"],
    ["SUV Cab Pune to Jyotirlinga", "Sedan Taxi Pune to Jyotirlinga"],
    ["Family Trip Cab Pune to Jyotirlinga", "Corporate Cab Pune to Jyotirlinga"],
    ["Weekend Trip Taxi Pune to Jyotirlinga", "AC Cab Pune to Jyotirlinga"],
    ["Online Booking Pune to Jyotirlinga", "Best Outstation Cab Pune to Jyotirlinga"],
    ["Per Km Rate Pune to Jyotirlinga", "Same Day Return Cab Pune to Jyotirlinga"],
    ["Group Tour Cab Pune to Jyotirlinga", "Picnic Cab Pune to Jyotirlinga"],
    ["Outstation Taxi Service Pune to Jyotirlinga", "Chauffeur Driven Cab Pune to Jyotirlinga"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Complete 5 Jyotirlinga Coverage",
      WhyChoosedescription:
        "Comprehensive pilgrimage package covering all five major Jyotirlinga temples from Pune with planned routing."
    },
    {
      WhyChooseheading: "Experienced Highway Drivers",
      WhyChoosedescription:
        "Professional chauffeurs familiar with temple routes ensure safe and smooth long-distance travel."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription:
        "Well-maintained sedans and SUVs provide relaxed travel for multi-day journeys."
    },
    {
      WhyChooseheading: "Flexible Multi-Day Packages",
      WhyChoosedescription:
        "Customizable itinerary options based on darshan schedule and traveler preferences."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear billing structure without hidden charges."
    },
    {
      WhyChooseheading: "Ideal for Family & Senior Citizens",
      WhyChoosedescription:
        "Spacious vehicles and smooth travel arrangements suitable for elderly passengers."
    },
    {
      WhyChooseheading: "Doorstep Pickup in Pune",
      WhyChoosedescription:
        "Convenient pickup from home, hotel, or railway station."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock customer assistance for trip planning and travel coordination."
    }
  ]
};

const faqData = [
  { question: "Which 5 Jyotirlinga temples are covered?", answer: "Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath are covered." },
  { question: "Is multi-day booking available?", answer: "Yes, customized multi-day pilgrimage packages are available." },
  { question: "Are SUV vehicles recommended?", answer: "Yes, SUVs are ideal for family and group temple tours." },
  { question: "Is fare calculated per km?", answer: "Yes, transparent per kilometer pricing is followed." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return cab option is available for nearby temples." },
  { question: "Are vehicles AC?", answer: "Yes, fully air-conditioned vehicles are provided." },
  { question: "Is online booking available?", answer: "Yes, instant online booking is available." },
  { question: "Are drivers experienced?", answer: "Yes, experienced highway chauffeurs ensure safe travel." },
  { question: "Is this suitable for senior citizens?", answer: "Yes, comfortable vehicles are suitable for elderly passengers." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock assistance is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Kulkarni",
    feedback:
      "Completed 5 Jyotirlinga yatra with Lotus Cab. Safe driving and comfortable SUV made our pilgrimage peaceful.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Deshmukh",
    feedback:
      "Family temple tour was well-planned and smooth. Transparent pricing and courteous driver.",
    rating: 5
  },
  {
    id: 3,
    name: "Group Pilgrimage Client",
    feedback:
      "Reliable multi-day cab service for Jyotirlinga tour. Highly recommended for spiritual travel.",
    rating: 5
  }
];





















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to 5 Jyotrilinga Cab",
  "image": "https://lotuscab.com/assets/images/pune-to-5-jyotrilinga-cab.jpg", 
  "description": "Lotus Cab provides taxi services from Pune to the 5 Jyotirlinga temples for one-way trips, round trips, family tours, corporate travel, weekend trips, and group pilgrimages. Choose from luxury, SUV, AC, and sedan cabs with chauffeur service, affordable per km rates, same-day return, and hassle-free online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-5-jyotrilinga-cab"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune to 5 Jyotrilinga Cab | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book taxi from Pune to 5 Jyotirlinga temples with Lotus Cab. One-way, round-trip, weekend, family & corporate trips. Luxury, SUV & AC cabs with chauffeur service. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Jyotirlinga Temples Cab, Pune to Jyotirlinga One Way Cab, Pune to Jyotirlinga Round Trip Taxi, Affordable Cab Pune to Jyotirlinga, Luxury Cab Pune to Jyotirlinga, SUV Cab Pune to Jyotirlinga, Sedan Taxi Pune to Jyotirlinga, Family Trip Cab Pune to Jyotirlinga, Corporate Cab Pune to Jyotirlinga, Weekend Trip Taxi Pune to Jyotirlinga, AC Cab Pune to Jyotirlinga, Online Booking Pune to Jyotirlinga, Best Outstation Cab Pune to Jyotirlinga, Per Km Rate Pune to Jyotirlinga, Same Day Return Cab Pune to Jyotirlinga, Group Tour Cab Pune to Jyotirlinga, Picnic Cab Pune to Jyotirlinga, Outstation Taxi Service Pune to Jyotirlinga, Chauffeur Driven Cab Pune to Jyotirlinga, Budget Luxury Cab Pune to Jyotirlinga" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetofivejyotilingacab;